const ACTION_TYPES = {
  RECEIVED_BUSINESS_DATA: 'RECEIVED_BUSINESS_DATA_V2',
  EDITED_BUSINESS_DATA: 'EDITED_BUSINESS_DATA_V2',
  VALIDATED_BUSINESS_DATA: 'VALIDATED_BUSINESS_DATA_V2',

  UPDATE_BUSINESS_DATA: 'UPDATE_BUSINESS_DATA_V2',
  CREATE_NEW_BUSINESS: 'CREATE_NEW_BUSINESS_V2',
};

export default ACTION_TYPES;
